export type EditorBlocksBlock = {
    id?: string,
    type: string,
    data: any,
    tunes?: any
};
export type EditorBlocks = {
    version: string,
    time: number,
    blocks: Array<EditorBlocksBlock>
};

export class BlockRenderer {
    public static render(blocks:EditorBlocks):string {
        let r = "";
        if(blocks==null||blocks.blocks==null) return r;

        for(let m in blocks.blocks) {
            let c = blocks.blocks[m];

            let classAddStr:string = "";
            if(c.tunes?.style?.style!=null) {
                classAddStr+=" style-"+c.tunes?.style?.style;
            }
            if(c.type=="header") {
                r+="<h"+c.data.level+">"+c.data.text+"</h"+c.data.level+">";
            } else if(c.type=="paragraph") {
                if(classAddStr!="") {
                    r+="<p class='"+classAddStr.trim()+"'>"+c.data.text+"</p>";
                } else {
                    r+="<p>"+c.data.text+"</p>";
                }
            } else if(c.type=="spacer") {
                r+="<div class='spacer' style='width:100%;height:"+c.data.height+"px;'></div>"
            } else if(c.type=="table") {
                //let _withHeadings = c.data.withHeadings||false; // <- ignored, no implementation so far, but kept here as reminder
                //let rows = c.data.content;
                let classStr = "";
                if(c.data.style!=null) {
                    classStr+=" "+c.data.style;
                }
                r+="<div class='block-table"+classStr+"'>";
                if(c.data.content!=null&&c.data.content.length>0) {
                    let numRows = c.data.content.length;
                    let numCols = c.data.content[0].length;
                    let cRow = 0;
                    let cCol = 0;
                    while(cCol<numCols) {
                        r+="<div class='block-table-col'>";
                        cRow = 0;
                        while(cRow<numRows) {
                            let content = c.data.content[cRow]?.[cCol];
                            r+="<div class='block-table-value'>";
                            if(content!=null) {
                                r+=content;
                            }
                            r+="</div>";
                            cRow++;
                        }
                        r+="</div>";
                        cCol++;
                    }
                }
                r+="</div>";
            } else if(c.type=="media") {
                let altinfo:string = '';
                if(c.data.alt!=null&&c.data.alt!="") altinfo = " alt='"+c.data.alt+"'";
                r+="<img src='"+c.data.url+"'"+altinfo+" />";
            } else if(c.type=="list") {
                let style:string = c.data?.style;
                if(style=="ordered") {
                    classAddStr+=" list-ordered";
                }
                if(classAddStr!="") {
                    r+="<ul class='"+classAddStr.trim()+"'>";
                } else {
                    r+="<ul>";
                }
                for(let m2 in c.data.items) {
                    let item = c.data.items[m2];
                    r+="<li>"+item+"</li>";
                }
                r+="</ul>";
            } else if(c.type=="button") {
                r+="<a class='vaxi-button' href='"+c.data.link+"' target='"+(c.data.target||"_self")+"'>";
                r+="<img src='static/icon_"+(c.data.icon||"pin")+".svg' alt='' />";
                r+=(c.data.text||"Klicka här");
                r+="</a>";
            } else {
                console.warn("Could not handle block of type " + c.type + " because there is no implementation for this render");
            }
        }
        return r;
    }
    public static getText(blocks:EditorBlocks):string {
        let r = "";
        if(blocks==null||blocks.blocks==null) return r;
        for(let m in blocks.blocks) {
            let c = blocks.blocks[m];
            if(c.type=="header"||c.type=="paragraph") {
                if(c.data.text!=null&&c.data.text!="") {
                    if(r!="") r+=" ";
                    r+=c.data.text;
                }
            }
        }
        return r;
    }
}